/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { AddressComponentMapperFactory } from './address-component-mapper-factory/address-component-mapper.factory';
import { AddressDTO, PointDtoModel } from '@well/address-management-domain-model';

export class AddressSearchResultMapper {
  private result: google.maps.places.PlaceResult | google.maps.GeocoderResult | undefined = undefined;

  constructor(result: any) {
    this.result = result;
  }

  public getAddress(): AddressDTO {
    let address: AddressDTO = new AddressDTO();
    const addressComponents = this.result?.address_components;
    for (const addressComponent of addressComponents) {
      this.mapAddressComponentToAddressModel(addressComponent, address);
    }
    address = this.mapAddressLineToAddress(address);
    if (this.result?.geometry?.location) {
      this.mapLocationToAddress(address);
    }
    return address;
  }

  private mapAddressComponentToAddressModel(addressComponent: any, addressModel: AddressDTO) {
    const addressComponentMapperFactory = new AddressComponentMapperFactory();
    const addressComponentMapper = addressComponentMapperFactory.createMapper(addressComponent);
    addressComponentMapper.mapAddress(addressModel);
  }

  private mapAddressLineToAddress(address: AddressDTO) {
    const formattedAddress = this.result?.formatted_address;

    return { ...address, ...this.extractStreetNameAndNumber(formattedAddress) };
  }

  private extractStreetNameAndNumber(formattedAddress: string) {
    const noStreetFoundText = 'Unnamed Road';
    if (!formattedAddress || formattedAddress.includes(noStreetFoundText)) {
      return { addressLine: '', streetName: '', streetNumber: '' };
    }

    const streetNameAndNumber = formattedAddress.split(',')[0].trim();
    const regex = /^(.*?)(?:\s+nr\.\s*|\s+)?(\d+\w*|\d+-\d+|FN)?$/i;
    const match = streetNameAndNumber.match(regex);

    return {
      addressLine: streetNameAndNumber,
      streetName: match?.[1]?.trim() || '',
      streetNumber: match?.[2]?.trim() || '',
    };
  }

  private mapLocationToAddress(address: AddressDTO) {
    const center: google.maps.LatLng = this.result?.geometry?.location;
    address.pointDTO = PointDtoModel.asPointDto(center);
  }
}
